export default "__VITE_ASSET__C2OO95CD__"